/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CarePrincipalAccessDTO
 */
export interface CarePrincipalAccessDTO {
    /**
     * 
     * @type {string}
     * @memberof CarePrincipalAccessDTO
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CarePrincipalAccessDTO
     */
    idType: CarePrincipalAccessDTOIdTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof CarePrincipalAccessDTO
     */
    expireDate?: Date;
}

/**
* @export
* @enum {string}
*/
export enum CarePrincipalAccessDTOIdTypeEnum {
    CareProvider = 'CareProvider',
    System = 'System'
}

export function CarePrincipalAccessDTOFromJSON(json: any): CarePrincipalAccessDTO {
    return CarePrincipalAccessDTOFromJSONTyped(json, false);
}

export function CarePrincipalAccessDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): CarePrincipalAccessDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'idType': json['idType'],
        'expireDate': !exists(json, 'expireDate') ? undefined : (new Date(json['expireDate'])),
    };
}

export function CarePrincipalAccessDTOToJSON(value?: CarePrincipalAccessDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'idType': value.idType,
        'expireDate': value.expireDate === undefined ? undefined : (value.expireDate.toISOString()),
    };
}

